var _rect, _path, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEarnedMiles(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.165,
    y: 0.665,
    width: 25.921,
    height: 25.921,
    rx: 12.96,
    fill: "#3C3C3C"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.777 10.136l-6.397 6.397-2.907-2.908",
    stroke: "#fff",
    strokeWidth: 1.745,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.165,
    y: 0.665,
    width: 25.921,
    height: 25.921,
    rx: 12.96,
    stroke: "#fff",
    strokeWidth: 1.329
  })));
}
export default __webpack_public_path__ + "static/media/earned-miles.4cecc6ae.svg";
export { SvgEarnedMiles as ReactComponent };